<template lang="pug">
  .events
    .container
      h2 Новогодний<br> калейдоскоп
      img.events__garland.forDesktop(src="@/assets/img/garland.png")
      img.events__garland.forMobile_or_p(src="@/assets/img/garland-mobile.png")
      .events__list
        .events__item(v-for="(event, key) in events"
          :key="key"
          :style="{backgroundImage: 'url('+event.PREVIEW_PICTURE+')'}")
          div
            .top
              h6(v-html="event.NAME")
              time(v-html="event.DATE")
            p(v-html="event.PREVIEW_TEXT")
          router-link.app-button(:to="getEventLink(event.CODE)") Подробнее
      //.app-button.more Смотреть больше
</template>

<script>
export default {
  name: "Events",
  props: {
    events: {}
  },
  methods: {
    getEventLink(code) {
      return {
        name: 'EventNewyear',
        params: {
          id: code
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.events {
  position: relative;
  padding-bottom: 11rem;

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  h2 {
    font-size: 5rem;
    font-weight: bold;
    text-align: center;
  }

  &__garland {
    width: 112%;
    margin: -2rem 0 2.6rem -6%;
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 5.5rem;
  }

  &__item {
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    width: 49.4%;
    margin-bottom: 1.4rem;
    padding: 3.3rem 3.6rem 2.7rem;
    border: 2px solid #fff;
    border-radius: 1.5rem;
    background: no-repeat center center / cover;
    color: #fff;
    &>div {
      width: 100%;
    }
    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: inherit;
      -webkit-filter: blur(3px) brightness(60%);
      -webkit-mask-box-image: -webkit-linear-gradient(0deg, black 45%, transparent 100%);
      @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
        background: rgba(#000, 0.6);
      }
      @media screen and (min-width: 0 \0) and (min-resolution: .001dpcm) {
        background: rgba(#000, 0.6);
      }
    }
    .top, p, .app-button {
      position: relative;
      z-index: 1;
    }
    .top {
      display: flex;
      justify-content: space-between;
      width: 100%;
      font-size: 2.25rem;
      line-height: 1.2;
      font-weight: bold;
    }

    h6 {
      max-width: 70%;
      margin-bottom: 1.3rem;
    }

    p {
      width: 100%;
      max-width: 87%;
      margin-bottom: 2.2rem;
      font-size: 1.25rem;
      line-height: 1.2;
    }

    .app-button {
      padding: 1rem 2.5rem;
    }
  }

  .app-button.more {
  }

  @include mobile_or_P {
    padding-bottom: 4rem;
    h2 {
      margin-bottom: 3.8rem;
      font-size: 2.25rem;
    }
    &__garland {
      width: 100%;
      margin: 0 0 2.9rem 1.5rem;
    }

    &__list {
      justify-content: center;
      margin-bottom: 2.35rem;
    }

    &__item {
      width: 100%;
      max-width: 100vmin;
      margin-bottom: 0.8rem;
      padding: 2rem 2rem 1.7rem;
      border-radius: 2rem;

      .top {
        font-size: 1.3rem;
      }

      h6 {
        margin-bottom: 0.75rem;
      }

      p {
        margin-bottom: 1.25rem;
        font-size: 0.72rem;
      }

      .app-button {
        padding: 0.5rem 1.4rem;
        font-size: 0.73rem;
      }
    }
  }
}
</style>